import React, { Component } from "react";

interface Props {
  name: string;
  onChange: (name: string, file: any) => void;
  onBlur: (
    field: string,
    isTouched?: boolean,
    shouldValidate?: boolean
  ) => void;
}

export default class FormikAttachmentField extends Component<Props> {
  private fileInput: React.RefObject<HTMLInputElement>;

  constructor(props: Props) {
    super(props);
    this.fileInput = React.createRef();
  }

  handleFileChange = () => {
    if (this.fileInput.current === null) return;

    const { files } = this.fileInput.current;
    if (files !== null) {
      if (files.length <= 0) {
        // Revert to null intentionally from default state
        this.props.onChange(this.props.name, null);
      } else {
        this.props.onChange(this.props.name, files[0]);
      }
    }
  };

  handleFileBlur = () => {
    if (this.fileInput.current === null) return;
    this.props.onBlur(this.props.name, true, false);
  };

  render() {
    return (
      <input
        type="file"
        ref={this.fileInput}
        onChange={this.handleFileChange}
        onBlur={this.handleFileBlur}
      />
    );
  }
}
